<template>
  <div class="my-1">
    <DocumentModal
      :visible="showDocumentModal"
      :title="activeDocument.title"
      :content="activeDocument.content"
      @close="closeDocument"
    />
    <ValidationProvider rules="required|accepted" v-slot="{ errors }">
      <div :class="[{ 'input-error': errors.length }]">
        <label class="flex items-start gap-2 cursor-pointer">
          <input
            type="checkbox"
            name="terms and conditions"
            class="form-checkbox checkbox-terms mt-1 mr-2"
            v-model="termsAccepted"
          />
          <span>
            {{ $t("reservation.attestationMessage") }}
            <a
              v-if="termsAndConditionsDocument.isLink"
              :href="termsAndConditionsDocument.content"
              target="_blank"
              rel="noopener noreferrer"
              class="text-main"
            >
              {{ $t("reservation.termsAndCondition") }}
            </a>
            <a
              v-else
              href="#"
              class="text-main"
              @click.prevent="
                openDocument(
                  $t('reservation.termsAndCondition'),
                  termsAndConditionsDocument.content
                )
              "
            >
              {{ $t("reservation.termsAndCondition") }}
            </a>
            {{ $t("reservation.andThe") }}
            <a
              v-if="privacyPolicyDocument.isLink"
              :href="privacyPolicyDocument.content"
              target="_blank"
              rel="noopener noreferrer"
              class="text-main"
            >
              {{ $t("reservation.privacyPolicy") }}
            </a>
            <a
              v-else
              href="#"
              class="text-main"
              @click.prevent="
                openDocument(
                  $t('reservation.privacyPolicy'),
                  privacyPolicyDocument.content
                )
              "
            >
              {{ $t("reservation.privacyPolicy") }}
            </a>
          </span>
        </label>
      </div>
      <span v-if="errors.length" class="text-danger small">
        {{ errors[0] }}
      </span>
    </ValidationProvider>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DocumentModal from "../Widgets/DocumentModal.vue";

export default {
  name: "TermsAndPolicies",
  components: {
    DocumentModal,
  },
  data() {
    return {
      termsAccepted: "",
      showDocumentModal: false,
      activeDocument: {
        title: "",
        content: "",
      },
    };
  },
  computed: {
    ...mapState("property", ["documents"]),
    termsAndConditionsDocument() {
      return this.documents?.termsAndConditions || { content: "", isLink: true };
    },
    privacyPolicyDocument() {
      return this.documents?.privacyPolicy || { content: "", isLink: true };
    },
  },
  methods: {
    openDocument(title, content) {
      if (!content) return;
      this.activeDocument = { title, content };
      this.showDocumentModal = true;
    },
    closeDocument() {
      this.showDocumentModal = false;
    },
  },
};
</script>

<style>
.checkbox-terms {
  transform: scale(1.5);
  accent-color: #007bff;
}
</style>